module.exports = __webpack_public_path__ + "img/bulbBlack.921e3995.gif";